import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import SearchNav from './searchNav';
import HeadLine from './headLine';
import Summary from './summary';
import Form from './form';
import Hot from './hot';
import CommentBox from './commentBox';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        surveyData: this.props.content.surveyData,
    };

    componentDidMount() {}
    setIframeHeight() {
        const iframe = document.getElementById('hotContent');

        if (iframe) {
            console.log(iframe);
            const iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;

            if (iframeWin.document.body) {
                const height = iframeWin.document.getElementById('root').getBoundingClientRect().height;

                iframe.height = height;
            }
        }
    }

    render() {
        const { content } = this.props;
        const { search, isLoginAuth } = content;
        const { surveyData } = this.state;

        console.log(surveyData);

        return surveyData && surveyData.surveyinfo ? (
            <div className={styles.content}>
                <SearchNav content={{ search, surveyinfo: surveyData.surveyinfo }} />
                <HeadLine content={surveyData.surveyinfo} />
                <Summary content={surveyData.surveyinfo} />
                <div className={styles.main}>
                    <div className={styles.left}>
                        <Form content={surveyData} isLoginAuth={isLoginAuth} />
                    </div>
                    <div className={styles.right} id="rightContent">
                        {/* <Hot /> */}
                        {/* <iframe
                            src="http://172.30.21.28:3000/pc/vote/survey/hot/index"
                            frameBorder="no"
                            id="hotContent"
                            width="100%"
                            className={styles.iframeheight}
                            onLoad={this.setIframeHeight}
                        /> */}
                        <iframe
                            src="https://vote.ifeng.com/survey/hot/index"
                            frameBorder="no"
                            id="hotContent"
                            width="100%"
                            className={styles.iframeheight}
                            onLoad={this.setIframeHeight}
                        />
                    </div>
                </div>
                {surveyData.surveysetting && Number(surveyData.surveysetting.iscomment) ? (
                    <CommentBox content={surveyData.surveyinfo} />
                ) : null}
            </div>
        ) : null;
    }
}

export default Content;
